/**
 * Cache singleton — same pattern as providerInstance.ts.
 *
 * main.ts creates the DataCache and registers it via setCache(). Panels
 * that perform mutations call getCache().invalidate(key) immediately so
 * the next refresh sees fresh data instead of stale TTL contents.
 *
 * Audit C6 — without this indirection mutations on a panel would only be
 * visible after the periodic refresh interval (default 5 min) or a manual
 * Refresh click.
 */

import { DataCache } from "./cache";

let cacheInstance: DataCache | null = null;

export function setCache(cache: DataCache): void {
  cacheInstance = cache;
}

export function getCache(): DataCache | null {
  return cacheInstance;
}

/** Convenience: invalidate one or all keys, no-op if cache not yet wired. */
export function invalidateCache(key?: string): void {
  cacheInstance?.invalidate(key);
}
